import {AppState} from '../../Root.store'

import {ErrorsState} from './Errors.types'

export const selectErrors = (state: AppState): ErrorsState => state.errors
export const selectErrorByKey = (state: AppState, key: string) => selectErrors(state).errors[key]
